import { GET_FIX_TIP_INVESTMENT } from '../../actions/types';

const initialState = {
  fixTipInvest: []
};

const fetchFixTipInvestment = (state = initialState, action) => {
  switch (action.type) {
    case GET_FIX_TIP_INVESTMENT:
      return {
        ...state,
        fixTipInvest: action.fixTip
      };
    default: return state;
  }
};

export default fetchFixTipInvestment;
